module.exports = __webpack_public_path__ + "porownanie3.png?fe967d7a51bfaff7cbda2ecad3917ef1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/porownanie3.png
// module id = 4
// module chunks = 0